module.exports = __webpack_public_path__ + "static/media/cardIllustrationBlack.352e83a4.svg";